<template>
	<router-link
		class="text-decoration-none"
		:to="{ name: 'product', params: { slug: product.slug } }"
	>
		<v-img
			width="100%"
			height="200"
			:src="product.primaryImage?.url"
			alt="product"
			class="rounded-sm"
		/>
		<div class="font-weight-bold text-sm-body-2 text-caption text-center">{{ product.name }}</div>
	</router-link>
</template>

<script>
export default {
	name: 'ProductVue',
	props: ['product'],
};
</script>

<style>
</style>
